import React from 'react';

export const Service = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="22"
      fill="none"
      viewBox="0 0 23 22"
    >
      <path
        stroke="#163E63"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.875"
        d="M14.7 19.513h.875c1.692 0 3.063-.934 3.063-2.625v-1.899"
      ></path>
      <path
        stroke="#163E63"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.875"
        d="M17.763 8.138a3.5 3.5 0 011.167 6.8.875.875 0 01-1.167-.824V8.138zm-13.125 0a3.5 3.5 0 00-1.168 6.8.875.875 0 001.168-.824V8.138z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#163E63"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.875"
        d="M17.762 9.45V7.7a6.563 6.563 0 00-13.125 0v1.75"
      ></path>
      <path
        stroke="#163E63"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.875"
        d="M10.762 18.638h3.5c.242 0 .438.196.438.437v.875a.438.438 0 01-.438.438h-3.5a.875.875 0 01-.875-.875v0c0-.484.392-.875.875-.875z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
